import { Fragment } from "react";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import IconButton from "../iconButton";
import TickIcon from "../../images/tick-icon.png";

const CreditRefundSuccessSlideOver = ({ handleClose, isError, error }) => {
  return (
    <div className="flex h-full flex-col bg-white py-5 md:py-10 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
      <div className="">
        {isError ? (
          <div className="col-left w-[60px] md:w-[80px] h-[60px] md:h-[80px] flex items-center justify-center bg-[#E8FFF5] rounded-[12px] mb-5 md:mb-[30px]">
            <XMarkIcon className="w-[64px] md:w-20 h-[64px] md:h-20 p-4 cursor-pointer text-[#EF2121] bg-[#FFEBEB] rounded-[10px]" />
          </div>
        ) : (
          <div className="col-left w-[60px] md:w-[80px] h-[60px] md:h-[80px] flex items-center justify-center bg-[#E8FFF5] rounded-[12px] mb-5 md:mb-[30px]">
            <img src={TickIcon} alt="" />
          </div>
        )}
        <div className="border-b border-solid border-[#CCD0D4] mb-5 pb-5">
          <div className="text-lg md:text-2xl font-bold leading-[160%] text-[#04091E]">
            {isError
              ? "Credit Refund Request Failed"
              : "Your credit refund request has been submitted and is under review."}
          </div>
        </div>
        <p className="text-base leading-[160%] text-[#485868]">
          {isError
            ? error
            : "Please check back here in 2-3 business days for an update to your request."}
        </p>
      </div>
      <div className="mt-[30px]">
        <IconButton
          classes="rounded-[10px] bg-primary text-sm md:text-base font-black uppercase text-white px-3 flex justify-center items-center gap-[6px] w-full mb-4 h-10 md:h-[58px]"
          icon={CheckCircleIcon}
          iconClasses="w-6 h-6 text-white"
          title="return to dashboard"
          onClick={handleClose}
        />
      </div>
    </div>
  );
};

export default CreditRefundSuccessSlideOver;
